import React, { useState, useEffect } from 'react';
// import styles from './AdvancedEnvironmentalIndicators.module.scss';
import styles from '../../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
import AdvancedNoFilterOptions from '../AdvancedNoFilterOptions/AdvancedNoFilterOptions'
import AdvancedEnvironmentalRCRA from './AdvancedEnvironmentalRCRA/AdvancedEnvironmentalRCRA'
import AdvancedEnvironmentalSuperfundNPL from './AdvancedEnvironmentalSuperfundNPL/AdvancedEnvironmentalSuperfundNPL'
import AdvancedEnvironmentalSuperfundNonNPL from './AdvancedEnvironmentalSuperfundNonNPL/AdvancedEnvironmentalSuperfundNonNPL'

const AdvancedEnvironmentalIndicators = (props) => {
const [rcraParams, setRCRAParams] = useState<Array<string>>([]);
const [superfundNPLParams, setSuperfundNPLParams]  = useState<Array<string>>([]);
const [superfundNonNPLParams, setSuperfundNonNPLParams] = useState<Array<string>>([]);

const updateRCRAParams = (paramArray) => {
  setRCRAParams(paramArray);
}

const updateSuperfundNPLParams = (paramArray) => {
  setSuperfundNPLParams(paramArray);
}

const updateSuperfundNonNPLParams = (paramArray) => {
  setSuperfundNonNPLParams(paramArray);
}

const updateAllEnvironmentalParams = () => {
const paramArray: Array<string> = [
  ...rcraParams,
  ...superfundNPLParams,
  ...superfundNonNPLParams
];
props.updateEnvironmentalParams(paramArray);
}


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { updateAllEnvironmentalParams(); }, [rcraParams, superfundNonNPLParams, superfundNPLParams]);

  useEffect(() => { }, [props.signalClear]);

  return (
    <div className={styles.SectionContainers}>
      <div className={styles.QuarterSections}>
        <AdvancedNoFilterOptions />
      </div>
      <div className={styles.QuarterSections}>
        <AdvancedEnvironmentalRCRA sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateRCRAParams={updateRCRAParams} />
      </div>
      <div className={styles.QuarterSections}>
        <AdvancedEnvironmentalSuperfundNPL sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateSuperfundNPLParams={updateSuperfundNPLParams} />
      </div>
      <div className={styles.QuarterSections}>
        <AdvancedEnvironmentalSuperfundNonNPL  sitesLayer={props.sitesLayer} signalClear={props.signalClear}
            matchesAny={props.matchesAny} updateSuperfundNonNPLParams={updateSuperfundNonNPLParams}/>
      </div>
    </div>
  );
}

export default AdvancedEnvironmentalIndicators;
